export namespace ShoppingExcelExportStatus {
    export const value= {
        Processing: 'Processing',
        Done: 'Done',
        Failed: 'Failed',
    } as const;

    export const description= {
        Processing: '진행중',
        Done: '완료',
        Failed: '실패',
    } as const;
}

